/**
 * Phone number anonymization
 * Return a phone number with 'X' instead of digits, expect for the last two ones.
 */
export const anonymizePhoneNumber = (phoneNumber: string): string => {
    return phoneNumber.slice(0, -2).replace(/\d/g, 'X') + phoneNumber.slice(-2);
};
